import { render, staticRenderFns } from "./social-auth.vue?vue&type=template&id=3386617e&scoped=true&"
import script from "./social-auth.vue?vue&type=script&lang=js&"
export * from "./social-auth.vue?vue&type=script&lang=js&"
import style0 from "./social-auth.vue?vue&type=style&index=0&id=3386617e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3386617e",
  null
  
)

export default component.exports